import React, { useRef, ChangeEvent, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { GFNButton } from '../ui/GFNButton';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchdata, viewdocdata, deletedocdata, adddata, UploadImageData, doceditdata, doceditdatanoimage } from './../reduxactions/organizationactions/OrgDocumentsActions';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { Calendar } from 'primereact/calendar';
import { Panel } from 'primereact/panel';



const OrganizationDocuments = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')


    const dispatch = useDispatch();

    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchdata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch]);



    const data = useSelector((state: RootState) => state.orgdoc.data);
    const docview = useSelector((state: RootState) => state.orgdoc.docview);
    const Deletedatas = useSelector((state: RootState) => state.orgdoc.deletedata);
    const adddatacheck = useSelector((state: RootState) => state.orgdoc.adddocdata);
    const [fileName, setFileName] = useState('');

    const handleChange = (e: ChangeEvent<any>, { value }: { value: Date }) => {
        setDate(value);
    };

    const [acceptfield, setfield] = useState(false);

    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const cancelfield = () => {
        setfield(false);
    }
    //To assign data 
    const viewupload = (rowData: any) => {
        console.log("RowData:", rowData)
        assignData.current = { did: rowData.DocID }

        setfield(true);
        fetchDataAsyncdialog()
    };
    const assignData = useRef({ did: '' })

    const fetchDataAsyncdialog = async () => {
        try {
            const { did } = assignData.current;
            console.log("DocID", did)
            await dispatch(viewdocdata(did) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }

    //To delete data 
    const [delData, setDeleteData] = useState({
        DocID: '',
    });
    //data from table 
    const Delete = (rowData: any) => {
        setDeleteData({
            DocID: rowData.DocID,
        });
        setDeleteConfirmation(true);
    };
    //To dispatch data to delete in fieldofficeraction.ts
    const confirmDelete = async () => {
        const { DocID } = delData;
        try {
            await dispatch(deletedocdata(DocID) as any);

            setDeleteConfirmation(false);
        } catch (error) {
            console.error('Error deleting data:', error);
        } toast.current.show({ severity: 'success', summary: 'Success', detail: Deletedatas, life: 3000 })
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchdata(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataAsync();

    };
    //To close dialog box
    const cancelDelete = () => {
        setDeleteConfirmation(false);
    };


    //To add property holder
    const [Adddocument, setAdddocument] = useState(false);
    const [document, setDocument] = useState<string>('');
    // const [date, setDate] = useState<Date | null>(new Date());
    const [date, setDate] = useState<Date | null>(null);

    console.log("setdate", setDate)

    console.log("date", date)
    const [file, setFile] = useState<string>('');


    //To add Adddocument dispatching data to ts
    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file)
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, uid) as any);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    const adddatafile = useSelector((state: RootState) => state.orgdoc.imagedata);
    console.log("adddatafile", adddatafile)

    const adduploads = async () => {
        const filename = adddatafile.filename;
        await dispatch(adddata(document, date, filename, uid) as any);
        setAdddocument(false);
        fetchDataAsync();
        toast2.current.show({ severity: 'success', summary: 'Document Added Successfully', detail: adddatacheck, life: 3000 })
    };


    const [Editdoc, SetEdit] = useState(false);

    const [editData, setEditData] = useState({
        CreteDate: '',
        doc_name: '',
        expiry_date: '',
        id: '',
        adddatafile: '',
        UserID: ''
    });

    //To dispatch edit data fieldofficer.ts
    const EditAdminManager = async () => {
        const filename = adddatafile.filename;
        if (adddatafile && adddatafile.filename) {

            console.log("Add file only called")
            const { doc_name, expiry_date, adddatafile, id, UserID } = editData;
            await dispatch(doceditdata(doc_name, expiry_date, filename, parseInt(id, 10), UserID) as any);
        } else {
            console.log("Without file only called")


            const { doc_name, expiry_date, id, UserID } = editData;
            await dispatch(doceditdatanoimage(doc_name, expiry_date, parseInt(id, 10), UserID) as any);
        }
        // fetchDataAsync();
        SetEdit(false);
        toast1.current.show({ severity: 'success', summary: 'Document Updated Successfully', detail: editdatasmsg, life: 3000 })

    }
    const editdatasmsg = useSelector((state: RootState) => state.orgdoc.editdata);
    const editupload = (rowData: any) => {
        setEditData({
            CreteDate: rowData.CreteDate,
            doc_name: rowData.doc_name,
            expiry_date: rowData.expiry_date,
            id: rowData.DocID,
            adddatafile: adddatafile,
            UserID: rowData.UserID

        });
        SetEdit(true);
    }
    const toast = useRef(Deletedatas);
    const toast1 = useRef(editdatasmsg);
    const toast2 = useRef(adddatacheck);
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-documents.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Documents</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card card-primary">
                                        <div className="card flex flex-wrap justify-content-end">
                                            <GFNButton label="Add Uploads" testId="add-uploads-btn" buttonType="primary" onClick={() => setAdddocument(true)} />
                                        </div>
                                        <div className="card flex flex-wrap justify-content-end my-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search ml-2" />

                                                <InputText
                                                    className="app-search-input"
                                                    value={globalFilter}
                                                    onChange={(e) => setGlobalFilter(e.target.value)}
                                                    placeholder="Global Search"
                                                />
                                            </span>
                                        </div>
                                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            <Column field="CreteDate" sortable header="Uploaded Date"></Column>
                                            <Column field="expiry_date" sortable header="Expiry Date"></Column>
                                            <Column field="doc_name" sortable header="Title "></Column>

                                            <Column header="Operation" body={(rowData, { rowIndex }) => (
                                                <>
                                                    <GFNButton icon="pi pi-eye" buttonType="primary"  tooltip="View" className='mr-3' testId={`view-btn-${rowIndex}`} onClick={() => viewupload(rowData)} />
                                                    <GFNButton icon="pi pi-pencil" testId={`edit-btn-${rowIndex}`} buttonType="success"  tooltip="Edit" aria-label="Edit" className='mr-3' onClick={() => editupload(rowData)} />
                                                    <GFNButton icon="pi pi-trash" buttonType="danger"  tooltip="Delete" testId={`delete-btn-${rowIndex}`} aria-label="Delete" className="mr-3" onClick={() => Delete(rowData)} />
                                                </>
                                            )} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
                            <div className="modal-header">
                                <GFNButton icon="pi pi-times" buttonType="secondary" size="sm" />
                            </div>
                            <div className="modal-body">
                                {docview.map((response: any, index: number) =>
                                    <div key={index}>
                                        {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                        {response.filetype !== 'photo' &&
                                            <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                        }

                                        {response.filetype === 'pdf' && (
                                            <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                                                Open PDF in New Tab
                                            </a>
                                        )}
                                    </div>
                                )}
                            </div>
                            <GFNButton label="Close" icon="pi pi-times" testId='close-btn' onClick={()=>setfield(false)} className="mr-3" buttonType="secondary" />
                        </Dialog>
                        {/* add dilog box */}
                        <Dialog header="Upload Document" visible={Adddocument} style={{ width: '30vw', height: '40' }} onHide={() => setAdddocument(false)} >
                            <div className='row'>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="name"   >Document Title:</label>
                                        </div>
                                        <div className="col md-3" >
                                            <InputText id="name" style={{ width: '15vw' }} data-testid='add-doc-input' name="document" placeholder='Document-title' onChange={(e) => setDocument(e.target.value)} />
                                        </div>
                                        <div className="col-2" ></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="year" >Expiry Date:</label>
                                        </div>
                                        <div className="col md-3" >
                                            {/* <Calendar
                                                id="expdate"
                                                style={{ width: '15vw' }}
                                                name="date"
                                                placeholder='dd-mm-yyyy'
                                                onChange={(e) => e.value && setDate(e.value)}
                                            /> */}
                                            <Calendar
                                                id="expdate"
                                                data-testid='add-edate-date'
                                                style={{ width: '15vw' }}
                                                name="date"
                                                placeholder="dd-mm-yyyy"
                                                value={date}
                                                onChange={(e) => setDate(e.value as Date)}
                                                dateFormat="dd-mm-yy"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="file" >Select File:</label>
                                        </div>
                                        <div className="col-3" >
                                            <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                            
                                        </div>
                                    </div>
                                </div> */}
                                <div className='row'>
                                    <div className="grid pt-3">

                                        <div className="col-3">
                                            <label htmlFor="file">Select File:</label>
                                        </div>

                                        <div className="col-3">
                                            <FileUpload
                                                mode="basic"
                                                id="fileToUpload"
                                                name="fileToUpload"
                                                customUpload
                                                accept="image/*"
                                                maxFileSize={1000000}
                                                uploadHandler={UploadManagerImage}
                                                auto
                                                onSelect={(e) => {
                                                    setFileName(e.files[0].name);
                                                }}
                                            />

                                            {fileName && (
                                                <div className="mt-2">
                                                    {fileName}
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <br></br>
                            <GFNButton label="Close" className="ml-2" testId='add-cancel-btn' buttonType="secondary" onClick={() => setAdddocument(false)} />
                            <GFNButton label="ADD" buttonType="primary" testId='add-add-btn' onClick={adduploads} style={{ float: 'right', marginRight: "30px" }} />
                        </Dialog>



                        <Dialog header="Upload Document" visible={Editdoc} style={{ width: '30vw', height: '40' }} onHide={() => SetEdit(false)} >
                            <div className='row'>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="name"   >Document Title:</label>
                                        </div>
                                        <div className="col md-3" >
                                            <InputText id="name" style={{ width: '15vw' }} data-testid='edit-doc-input' name="Doctitle" onChange={(e) => setEditData({ ...editData, doc_name: e.target.value })} value={editData.doc_name} />
                                        </div>
                                        <div className="col-2" ></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="year" >Expiry Date:</label>
                                        </div>
                                        <div className="col md-3" >
                                            {/* <Calendar id="expdate" value={editData.expiry_date} style={{ width: '15vw' }} name="date" placeholder='dd-mm-yyyy' onChange={(e) => setEditData({ ...editData, expiry_date: e.value as Date | null })}  /> */}
                                            <InputText id="expdate" type="date" style={{ width: '15vw' }} data-testid='edit-edate-date' name="date" onChange={(e) => setEditData({ ...editData, expiry_date: e.target.value })} value={editData.expiry_date} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="file" >Select File:</label>
                                        </div>
                                        <div className="col-3" >

                                            <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <GFNButton label="Close" className="ml-2" testId='edit-close-btn' buttonType="secondary" onClick={() => SetEdit(false)} />
                            <GFNButton label="Update" testId='edit-update-btn' buttonType="success" onClick={EditAdminManager} style={{ float: 'right' }} />
                        </Dialog>

                        <Dialog header="Confirm Delete" style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                            <div>Are you sure you want to delete this item?</div>
                            <GFNButton label="Delete" icon="pi pi-check" testId='delete-btn' className='mr-3 mt-3' buttonType="danger" onClick={()=>setDeleteConfirmation(false)} />
                            <GFNButton label="Close" icon="pi pi-times" testId='close-btn' onClick={cancelDelete} className="mr-3 mt-3" buttonType="secondary" />
                        </Dialog>

                        <Toast ref={toast} >
                            <Message severity="success" content={Deletedatas}></Message>
                        </Toast>
                        <Toast ref={toast1} >
                            <Message severity="success" content={editdatasmsg}></Message>
                        </Toast>
                        <Toast ref={toast2} >
                            <Message severity="success" content={adddatacheck}></Message>
                        </Toast>
                    </div>
                </div>
            </div>
        </div>
    )

}
export default OrganizationDocuments